var o=function(){return"undefined"!=typeof global&&global.process&&global.process.versions&&global.process.versions.node};export{o as isServer};
